<template>
	<div>
		<Header></Header>
		<Search></Search>
		<Nav></Nav>
		<div class="box" :style="backgroundimg">
			<div class="w">
				<!-- //切换 -->
				<div class="tab d-flex">
					<div class="tab-item  d-flex align-items-center justify-content-center" v-for="item in 5" :key="item" @click="seckillTab(item)"
					 :class="{active:tabIndex == item}">
						<div class="item-time">14:00</div>
						<div class="item-btn d-flex align-items-center justify-content-center" v-if="tabIndex != item">即将开始</div>
						<div class="item-djs" v-if="tabIndex == item">
							<div>正在秒杀</div>
							<div>距结束01:05:08</div>
						</div>
					</div>
				</div>
				<!-- 列表 -->
				<div class="list d-flex flex-wrap">
					<div v-for="items in 16" :key="items" class="list-item">
						<div class="item-img">
							<img class="img-default" src="../../assets/images/banner_4.jpg" alt="">
						</div>
						<div class="item-name">李宁外套男官方正品2020夏秋季连帽李宁外套男官方正品2020夏秋季连帽</div>
						<!-- 进度条 -->
						<div class="schedule d-flex align-items-center justify-content-between">
							<div class="schedule-item">
								<span style="width:50%"></span>
							</div>
							<div class="schedule-right d-flex align-items-center">
								<div class="img">
									<img class="img-default" src="../../assets/images/huoqing.svg" alt="">
								</div>
								<div class="num">已抢50%</div>
							</div>
						</div>
						<div class="bottom d-flex justify-content-between align-items-center">
							<div class="pic">
								<span>￥98.00</span>
								<del>¥159</del>
							</div>
							<div class="btn d-flex align-items-center justify-content-center">立即抢购</div>
						</div>
					</div>
				</div>
				<div class="ttshop_myorderpage clearfloat">
					<el-pagination class="ttshop_pages" background layout="prev, pager, next" :total="40"></el-pagination>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Search from "@/components/search/search";
	import Nav from "@/components/nav/nav";
	import Foot from "@/components/foot/foot";
	export default {
		components: {
			Search,
			Header,
			Nav,
			Foot,
		},
		data() {
			return {
				backgroundimg: {
					backgroundImage: "url(" + require("../../assets/images/seckill_bg.png") + ")",
				},
				tabIndex: 1,
				value: 4,
			};
		},
		created() {},
		methods: {
			seckillTab(index) {
				if (this.tabIndex != index) {
					this.tabIndex = index;
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.active {
		background: #ff0e25;

		.item-time {
			color: #fff;
		}
	}

	.box {
		background-color: #f2f2f2;
		background-position: top center;
		background-repeat: no-repeat;
		position: relative;
		border-top: 2px solid #ff0e25;
		padding-bottom: 80px;
		box-sizing: border-box;
	}

	.tab {
		height: 60px;
		width: 100%;
		background: #fff;
		margin-top: 30px;
		margin-bottom: 12px;

		.tab-item {
			width: 25%;
			height: 60px;
			cursor: pointer;

			.item-time {
				font-weight: 600;
			}

			.item-btn {
				width: 78px;
				height: 28px;
				border-radius: 14px;
				border: 1px solid #d4d4d4;
				margin-left: 16px;
			}

			.item-djs {
				margin-left: 11px;

				div {
					color: #fff;
				}
			}
		}
	}

	.list {
		width: 100%;
		padding-top: 12px;
		box-sizing: border-box;

		.list-item {
			width: 290px;
			height: 396px;
			background: #ffffff;
			margin-right: 10px;
			margin-bottom: 10px;
			padding: 20px 20px 22px 20px;
			box-sizing: border-box;

			&:nth-child(4n) {
				margin-right: 0;
			}

			.item-img {
				height: 250px;
				width: 250px;
				img{
					display: block;
					object-fit: cover;
				}
			}

			.item-name {
				width: 250px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				margin-top: 14px;
				color: #666666;
			}

			.schedule {
				margin-top: 12px;

				.schedule-item {
					width: 153px;
					height: 8px;
					background: #e6e6e6;
					border-radius: 4px;

					span {
						height: 8px;
						display: block;
						background: #df2021;
						border-radius: 4px;
					}
				}

				.schedule-right {
					.img {
						width: 12px;
						height: 14px;
						img{
							display: block;
						}
					}

					.num {
						color: #666666;
						margin-left: 4px;
					}
				}
			}

			.bottom {
				margin-top: 12px;

				.pic {
					span {
						color: #ff4300;
						font-size: 20px;
					}

					del {
						color: #999999;
						margin-left: 8px;
					}
				}

				.btn {
					width: 88px;
					height: 36px;
					background: linear-gradient(270deg, #ff0e25 0%, #ff9010 100%);
					background: -moz-linear-gradient(270deg, #ff0e25 0%, #ff9010 100%);
					background: -webkit-gradient(270deg, #ff0e25 0%, #ff9010 100%);
					background: -ms-linear-gradient(270deg, #ff0e25 0%, #ff9010 100%);
					filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#ff0e25, endColorstr=#ff9010);
					border-radius: 2px;
					font-size: 14px;
					color: #ffffff;
				}
			}
		}
	}
	.ttshop_myorderpage{
		width: 100%;
		margin-top: 20px;
		.ttshop_pages{
			display: table;
			margin: 0 auto;
		}
	}
</style>
